export const categories = [
  "AI and ML",
  "Analytics",
  "Asset Management",
  "Business Automation",
  "Compute and Servers",
  "Databases",
  "DevOps",
  "IT Automation",
  "Middleware",
  "Networking",
  "Operating Systems",
  "Operations",
  "Quantum",
  "Security",
  "Storage",
  "Supply Chain",
  "Sustainability",
];

export const colors = [
  { name: "Cyan", p10: "#e5f6ff", p20: "#bae6ff", p30: "#82cfff", p40: "#33b1ff", p50: "#1192e8" },
  { name: "Green", p10: "#defbe6", p20: "#a7f0ba", p30: "#6fdc8c", p40: "#42be65", p50: "#24a148" },
  { name: "Purple", p10: "#f6f2ff", p20: "#e8daff", p30: "#d4bbff", p40: "#be95ff", p50: "#a56eff" },
  { name: "Red", p10: "#fff1f1", p20: "#ffd7d9", p30: "#ffb3b8", p40: "#ff8389", p50: "#fa4d56" },
  { name: "Teal", p10: "#d9fbfb", p20: "#9ef0f0", p30: "#3ddbd9", p40: "#08bdba", p50: "#009d9a" },
  { name: "Yellow", p10: "#fcf4d6", p20: "#fddc69", p30: "#f1c21b", p40: "#d2a106", p50: "#b28600" },
];

export const levers = ["AI", "Automation", "Cloud", "Data Driven", "Modernize", "Secure", "Transform"];

export const patterns = [
  {
    320: { t: [32, 8], r: [0, 136], b: [64, 24], p: [208, 8], y: [128, 48] },
    672: { t: [108, 12], r: [36, 180], b: [156, 36], p: [456, 36], y: [384, 0] },
    1056: { t: [480, 96], b: [512, 48], p: [864, 16], y: [512, 48] },
    1312: { t: [720, 16], r: [656, 272], b: [784, 48], p: [1072, 16], y: [912, 96] },
    1584: { t: [816, 16], r: [768, 272], b: [864, 48], p: [1184, 144, true], y: [1200, 96] },
  },
  {
    320: { t: [32, 8], r: [0, 136], b: [64, 24], p: [208, 8], y: [128, 48] },
    672: { t: [108, 12], r: [36, 180], b: [156, 36], p: [456, 36], y: [384, 0] },
    1056: { t: [480, 96], b: [512, 48], p: [864, 16], y: [512, 48] },
    1312: { t: [720, 16], r: [656, 272], b: [784, 48], p: [1072, 16], y: [912, 0] },
    1584: { t: [816, 16], r: [768, 272], b: [864, 48], p: [1184, 144, true], y: [1200, 0] },
  },
  {
    320: { t: [32, 8], r: [0, 136], b: [64, 24], p: [208, 8], y: [128, 0] },
    672: { t: [108, 12], r: [36, 180], b: [156, 36], p: [444, 36], y: [384, 48] },
    1056: { t: [480, 96], b: [512, 64], p: [864, 16], y: [512, 96] },
    1312: { t: [720, 16], r: [656, 272], b: [784, 48], p: [1072, 16], y: [784, 96] },
    1584: { t: [816, 16], r: [768, 272], b: [864, 48], p: [1184, 144, true], y: [1024, 96] },
  },
  {
    320: { t: [32, 8], r: [0, 136], b: [64, 24], p: [208, 8], y: [128, 0] },
    672: { t: [108, 12], r: [36, 180], b: [156, 36], p: [444, 36], y: [372, 36] },
    1056: { t: [480, 96], b: [512, 64], p: [864, 16], y: [512, 96] },
    1312: { t: [720, 16], r: [656, 272], b: [784, 48], p: [1072, 16], y: [784, 0] },
    1584: { t: [816, 16], r: [768, 272], b: [864, 48], p: [1184, 144, true], y: [1024, 0] },
  },
];

export const shapes = ["Bundle", "Community", "Data", "Hardware", "Other", "Software"];
